<script>
	import {Col, Container, Row} from "sveltestrap";
	import MaskDetector from './MaskDetector.svelte';

	let img_url = 'https://raw.githubusercontent.com/mkirchler/style-transfer-models/master/imgs/';
	let header1 = img_url + 'M4KB_Gemeinsam_digital_300dpi.png';
	let header2 = img_url + 'logo_md40_kompetenzzentrum_berlin_RGB.png';
	let footer1 = img_url + 'MittelstandDigital_Single_CMYK.jpg';
	let footer2 = img_url + 'BMWi_Fz_2017_Web_de.gif';

</script>


<Container>
	<!--
	<Row>
		<Col xs="2">
			<div class='header'>
				<img src={header1} alt="logo-gd">
			</div>
		</Col>
		<Col xs="8">
		</Col>
		<Col xs="2">
			<div class='header'>
				<img src={header2} alt="logo-mittelstand4.0">
			</div>
		</Col>
	</Row>
	-->

	<Row>
		<Col xs="2"></Col>
		<Col xs="8">
			<h2>Gesichtsmaskenerkennung</h2>
			<p class="description">
				Das Tragen einer Mund-Nasen-Bedeckung ist ein wichtiger Bestandteil unseres Alltags geworden.
				Unser Demonstrator “Automatische Gesichtsmaskenerkennung” wendet maschinelles Lernen an, um zu erkennen, ob ein:e Anwender:in eine Gesichtsmaske trägt.
				In einem Videostream wird das Gesicht des Nutzers zusammen mit einer Box visualisiert, die entweder rot oder grün dargestellt wird, je nachdem ob der/die Anwender:in eine Mund-Nasen-Bedeckung trägt.
				Diese Applikation könnte in Alltagssituationen Anwendung finden, um Menschen zu erinnern oder zum Tragen einer Maske zu motivieren.
				Das zugrunde liegende Verfahren ist die Objektdetektion, die unter anderem auch in der Qualitätssicherung im Fabrikbetrieb zum Einsatz kommen kann.
				Dementsprechend breit ist das Anwendungsfeld und die Relevanz für klein- und mittelständische Unternehmen.
			</p>
		</Col>
		<Col xs="2"></Col>
	</Row>

<Row>

	<Col xs="2"></Col>
	<Col xs="8">
		<MaskDetector />
	</Col>
	<Col xs="2"></Col>
</Row>



	<Row>
		<hr/>

	</Row>
	<Row>
		<Col xs="2">
			<div class='footer'>
				<img src={footer1} alt='logo-mittelstand-digital'>
			</div>
		</Col>
		<Col xs="8">
		</Col>
		<Col xs="2">
			<div class='footer'>
				<img src={footer2} alt='logo-bmwi'>
			</div>
		</Col>
	</Row>

</Container>

<style>
	.description {
		margin-bottom: 100px;
		margin-top: 60px;
	}
	.header {
		margin-top: 50px;
		margin-bottom: 50px;
	}
	.footer img {
		width: 100%;
		/* height: 100%; */
	}
	.header img {
		width: 100%;
	}
	h2, p {
		text-align: center;
	}
	.footer {
		margin-top: 50px;
		margin-bottom: 50px;

	}
	hr {
		margin-top: 90px;
	}
</style>